var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center items-center w-9 h-9 rounded-md"},[_c('p',{staticClass:"font-bold text-white",domProps:{"textContent":_vm._s(_vm.pageNumber)}})])}
var staticRenderFns = []

export { render, staticRenderFns }